import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import TruncateInlineString from 'personalization-lib/components/shared/display/TruncateInlineString';
import EditContentButton from 'personalization-lib/components/navigation/EditContentButton';
import { createAssetCoordinates } from 'personalization-lib/utils/assetTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VariantGenerationSuccessAlertBody = ({
  assetType,
  assetId,
  assetName
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "personalizationLib.contentEditor.alerts.aiGeneration.success",
    options: {
      variantName: /*#__PURE__*/_jsx(TruncateInlineString, {
        text: assetName,
        placement: "bottom"
      })
    }
  }), /*#__PURE__*/_jsx(EditContentButton, {
    assetCoordinates: createAssetCoordinates(assetType, assetId.toString()),
    label: I18n.text('personalizationLib.contentEditor.alerts.aiGeneration.viewVariant'),
    use: "tertiary-light",
    size: "xs",
    marginInlineStart: "200"
  })]
});
export default VariantGenerationSuccessAlertBody;